<template>
  <TableLayout :permissions="['meihui:templateComponent:query']">
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="80px" inline>
      <el-form-item label="模板配置ID"><el-input v-model="searchForm.templateConfigId" placeholder="模板配置ID" @keypress.enter.native="search" /></el-form-item>
      <section><el-button type="primary" @click="search">搜索</el-button><el-button @click="reset">重置</el-button></section>
    </el-form>
    <template v-slot:table-wrap>
      <ul class="toolbar">
        <li><el-button type="primary" @click="$refs.opera.open('新建模板组件')" icon="el-icon-plus" v-permissions="['meihui:templateComponent:create']">新建</el-button></li>
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['meihui:templateComponent:delete']">批量删除</el-button></li>
      </ul>
      <el-table v-loading="isWorking.search" :data="tableData.list" stripe @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column prop="id" label="ID" width="80" show-overflow-tooltip />
        <el-table-column prop="templateConfigId" label="模板配置ID" width="120" show-overflow-tooltip />
        <el-table-column prop="componentKey" label="组件标识" width="150" show-overflow-tooltip />
        <el-table-column prop="componentName" label="名称" width="150" show-overflow-tooltip />
        <el-table-column prop="sortOrder" label="排序" width="80" show-overflow-tooltip />
        <el-table-column prop="isVisible" label="可见" width="80" show-overflow-tooltip />
        <el-table-column prop="createTime" label="创建时间" width="180" show-overflow-tooltip />
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.opera.open('编辑模板组件', row)" icon="el-icon-edit" v-permissions="['meihui:templateComponent:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['meihui:templateComponent:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination @size-change="handleSizeChange" @current-change="handlePageChange" :pagination="tableData.pagination" />
    </template>
    <operatemplateComponentWindow ref="opera" @success="handlePageChange" />
  </TableLayout>
</template>
<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import operatemplateComponentWindow from './operatemplateComponentWindow'
export default {
  name: 'TemplateComponent', extends: BaseTable, components: { TableLayout, Pagination, operatemplateComponentWindow },
  data() { return { searchForm: {} } },
  created() {
    this.config({ module: '模板组件', api: '/rentHouse/templateComponent', 'field.id': 'id', 'field.main': 'componentName' })
    this.search()
  }
}
</script>